<template>
  <div class="col s12 m6">
    <div>
      <div class="page-subtitle">
        <h4>{{'edit' | langFilter}}</h4>
      </div>

      <form @submit.prevent="submitHandler">
        <div class="input-field">
          <select ref="select" v-model="id">
            <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{cat.name}}</option>
          </select>
          <label>{{'chooseCategory' | langFilter}}</label>
        </div>

        <div class="input-field">
          <input
            id="name2"
            type="text"
            v-model="name"
            :class="{'invalid': $v.name.$dirty && $v.name.$invalid}"
          />
          <label for="name2">{{'name' | langFilter}}</label>
          <span
            class="helper-text invalid"
            v-if="$v.name.$dirty && $v.name.$invalid"
          >{{'typeName' | langFilter}}</span>
        </div>

        <div class="input-field">
          <input
            id="limit2"
            type="number"
            v-model="limit"
            :class="{'invalid': ($v.limit.$dirty && !$v.limit.minValue) || ($v.limit.$dirty && !$v.limit.required)}"
          />
          <label for="limit2">{{'limit' | langFilter}}</label>
          <span
            class="helper-text invalid"
            v-if="$v.limit.$dirty && !$v.limit.minValue"
          >{{'valueMin' | langFilter}} {{$v.limit.$params.minValue.min}}</span>
          <span
            class="helper-text invalid"
            v-if="$v.limit.$dirty && !$v.limit.required"
          >{{'typeAmount' | langFilter}}</span>
        </div>

        <button class="btn waves-effect waves-light" type="submit">
          {{'refresh' | langFilter}}
          <i class="material-icons right">send</i>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import langFilter from '../filters/lang.filter'
export default {
  props: ['categories'],
  data: () => ({
    limit: 100,
    name: "",
    id: null,
    select: null
  }),
  watch: {
    id(val) {
      this.name = this.categories.find(item => item.id === val).name
    }
  },
  created(){
    this.name = this.categories[0].name;
    this.id = this.categories[0].id
  },
  async mounted() {
    this.select = M.FormSelect.init(this.$refs.select);
    M.updateTextFields();
  },
  updated() {
     M.updateTextFields();
  },
  methods: {
    async submitHandler() {
      if (this.$v.$invalid) {
        this.$v.limit.$touch();
        this.$v.name.$touch();
        return;
      }
      const categoryData = {id: this.id, name: this.name, limit: this.limit};
      try{
        await this.$store.dispatch('updateCat', categoryData)
        this.limit = 100
        this.name =  ""
        this.$emit('edited', categoryData)
        this.$message(langFilter('succesCatUpdate'))
      } catch (e){}
    }
  },
  destroyed(){
    if (this.select){
      this.select.destroy()
    }
  },
  validations: {
    name: { required },
    limit: { required, minValue: minValue(100) }
  }
};
</script>